/* eslint-disable import/no-default-export */
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import { Storage } from '@trello/storage';
import { forTemplate } from 'app/common/lib/util/i18n';
import { State } from 'app/gamma/src/modules/types';
import React from 'react';
import { connect } from 'react-redux';
import { getMe } from 'app/gamma/src/selectors/members';
import { MemberModel } from 'app/gamma/src/types/models';
import HeaderLink from './header-link';

import styles from './header.less';

const format = forTemplate('header_back_menu_button');

interface BackToHomeLinkStateProps {
  me: MemberModel | undefined;
}

class BackToHomeLink extends React.Component<BackToHomeLinkStateProps> {
  onClick = (e: React.MouseEvent<HTMLElement>) => {
    const { me } = this.props;
    const cachedRoute = me
      ? String(Storage.get(`home_${me.id}_last_tab_2`))
      : null;
    let tab = '';
    if (cachedRoute === '/') {
      tab = 'home';
    } else if (cachedRoute && cachedRoute.endsWith('/boards')) {
      tab = 'boards';
    } else if (
      cachedRoute &&
      (cachedRoute.endsWith('/home') ||
        cachedRoute.endsWith('/highlights') ||
        cachedRoute.includes('/cards/'))
    ) {
      tab = 'team';
    }

    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.LANDING_TAB,
      method: 'by clicking home icon',
      context: {
        landingtab: tab,
      },
    });
  };
  render() {
    return (
      <HeaderLink
        aria-label={format('backToHome')}
        buttonStyle={'headerButton'}
        className={styles.backToHomeLink}
        onClick={this.onClick}
        href={'/'}
      >
        <Icon color={IconColor.Light} medium name={IconName.House} />
      </HeaderLink>
    );
  }
}

const mapStateToProps = (state: State): BackToHomeLinkStateProps => {
  return {
    me: getMe(state),
  };
};

export default connect(mapStateToProps)(BackToHomeLink);
